// @flow
import type { Element } from 'react'
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import './styles.scss'
import config from 'config'
import { type Municipality as MunicipalityType } from 'sources/types'
import { MunicipalitySearch } from 'components/municipalitySearch'

export type listProps = {
  list: Array<MunicipalityType>,
  setActiveMunicipalityHandler: number => void,
  lookupString: string,
  isSortedAscending: boolean,
  onIncreaseShownLines: number => void,
  onFlipSortOrder: () => void,
  onSearchTermChange: () => void
}

export function List ({
  list,
  lookupString,
  isSortedAscending,
  onIncreaseShownLines,
  onFlipSortOrder,
  onSearchTermChange,
  setActiveMunicipalityHandler
}: listProps): Element<any> {
  return (
    <div className='municipality list'>
      <MunicipalitySearch />
      <table
        className='ui very compact small unstackable selectable attached table'
        onMouseLeave={() => setActiveMunicipalityHandler(-1)}
      >
        <thead>
          <tr>
            <th />
            <th>Commune</th>
            <th className='canton'>Canton</th>
            <th className='right aligned single line'>
              <span className='canton'>Taxation</span>
              <span className='short'>Tax.</span>
              <a
                className='ui compact basic tiny icon button'
                onClick={onFlipSortOrder}
              >
                <i
                  className={`sort content ${
                    isSortedAscending ? 'ascending' : 'descending'
                  } icon`}
                />
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          {list !== undefined &&
            list.map((municipality, index) => {
              return (
                <Municipality
                  key={index}
                  {...municipality}
                  handler={setActiveMunicipalityHandler}
                />
              )
            })}
        </tbody>
      </table>
      {lookupString === '' && (
        <a
          className='ui basic bottom attached button'
          onClick={() => onIncreaseShownLines(20)}
        >
          <i className='plus icon' />
          Montrer les 20 communes suivantes
        </a>
      )}
    </div>
  )
}

function Municipality ({
  Gemeindename,
  Kanton,
  Belastung,
  GemeindeID,
  handler,
  Rank
}: {
  ...MunicipalityType,
  handler: number => void
}) {
  return (
    <tr onMouseOver={() => handler(+GemeindeID)}>
      <td className='right aligned'>{Rank}</td>
      <td>{Gemeindename}</td>
      <td className='canton'>{Kanton}</td>
      <td className='right aligned'>{config.formatAsDecimal(Belastung)}%</td>
    </tr>
  )
}

export default List



// WEBPACK FOOTER //
// ./src/components/list/component.js